module.exports = __webpack_public_path__ + "img/card-media-slider-02.a20ea577.png";